import {Component, OnInit} from '@angular/core';
import {AppTitleService} from '../../app-title.service';
import {Router} from '@angular/router';
import {UserIntegrityService} from '../../user-integrity.service';

@Component({
    selector: 'app-required-personal-step',
    templateUrl: './required-personal-step.component.html',
    styleUrls: ['./required-personal-step.component.scss']
})
export class RequiredPersonalStepComponent implements OnInit {
    public onPersonalRequiredScreen = false;
    public onPersonalDataScreen = true;

    constructor(
        private router: Router,
        private titleService: AppTitleService,
        private userIntegrityService: UserIntegrityService,
    ) {}

    ngOnInit(): void {
        this.titleService.setTitle('Se requiere tu inf. personal');
    }

    public confirmChanges(event: any): void {
        let validName = false;
        const checkerValue = this.userIntegrityService.currentValue;

        const { nombre, ap_paterno, ap_materno } = event;
        const { phone, card, zip } = checkerValue;

        if (this.checkProp(nombre) && this.checkProp(ap_paterno) && this.checkProp(ap_materno)) {
            validName = true;
        }

        console.log(phone, card, zip);

        if (phone === 1 && card === 1 && zip === 1 && validName) {
            console.log('Redirecting to dashboard');
            this.router.navigate(['/app/dashboard/cards']);
            return;
        }

        this.userIntegrityService.checkNow();
    }

    private checkProp(data: any): boolean {
        return data && data !== '';
    }
}
